import axios from 'axios';
import store from "../appRedux/store/index";
import { userSignOut } from '../appRedux/actions';

let mainInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  }
});

const isAuthLifecycleRequest = (url = '') =>
  url.includes('/api/auth/refresh') || url.includes('/api/auth/signout');

mainInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const isUnauthorized = error.response && error.response.status === 401;

    // Refresh and sign-out own their failure handling. Dispatching userSignOut
    // here for those endpoints can cause duplicate or recursive sign-out calls.
    if (isUnauthorized && !isAuthLifecycleRequest(error.config && error.config.url)) {
      store.dispatch(userSignOut());
    }
    return Promise.reject(error);
  },
);

export default mainInstance;
